
  import { Component, Vue } from 'vue-property-decorator'
  import { TableHeaderConfig } from '@/views/interfaces/vuetify/table.interface';
  import Themeable from 'vuetify/lib/mixins/themeable'
  import IPSetRepository from '@/services/IPSet';
  import { APIIPSetListInterface, IpSetListInterface } from '@/services/IPSet/Interfaces';
  import IpSetList from '@/services/IPSet/Models/IpSetList';

  @Component({
    mixins: [
      Themeable,
    ],
    inject: [
      'ipsetRepository',
    ],
  })
  export default class AllIPSetLists extends Vue {
    public readonly ipsetRepository!: IPSetRepository

    public loading: boolean = true
    public headers: TableHeaderConfig[] = [
      { text: 'Name', value: 'name', sortable: true },
      { text: 'Type', value: 'type', sortable: false },
      { text: 'Timeout', value: 'defaultTimeout', sortable: false },
      { text: 'Actions', value: 'actions', sortable: false },
    ]

    public search: string = ''
    public ipSetLists: IpSetListInterface[] = []

    public created(): void {
      this.updateIpSetLists()
    }

    public async updateIpSetLists(): Promise<void> {
      try {
        const apiIpSetLists = await this.ipsetRepository.getIpSetsList()

        this.ipSetLists = []
        apiIpSetLists.map((ipSet: APIIPSetListInterface) => {
          this.ipSetLists.push(new IpSetList(
            ipSet.name,
            ipSet.type,
            ipSet.timeoutSupport,
            ipSet.defaultTimeout,
            ipSet.commentsSupport,
            ipSet.counters,
            ipSet.skbInfo,
            ipSet.hashSize,
            ipSet.maxElements,
            ))
        })
      } catch (e) {
        this.$errorDialog.show('Failed to load Lists: ' + e.message);
      } finally {
        this.loading = false
      }
    }

    public createNewIPSet(): void {
      this.$router.push({ name: 'ipset_list_create' })
    }

    public editIPSet(): void {
      console.log('editing ipset list')
    }

    public async deleteIPSet(listName: string): Promise<void> {
      try {
        const res = await this.ipsetRepository.deleteIpSetList(listName)
        this.$successDialog.show(`Successfully deleted IPSet List '${listName}'`)
        await this.updateIpSetLists()
      } catch (e) {
        this.$errorDialog.show(e.response.data.error)
      }
    }
  }
